"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSpeed = exports.updateAll = exports.reset = void 0;
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var _speed = 0;
var reset = function () {
    if (_speed > 0) {
        if (objs.length === 0) {
            for (var i = 0; i < 2500; i++) {
                createStar();
            }
        }
        for (var i = 0; i < objs.length; i++) {
            var c = objs[i];
            randomizeStar(c);
        }
        voyageLayers_sidecar_1.voyageLayers.getLayers().starfield2.sort('depth');
    }
    updateAll();
};
exports.reset = reset;
var colors = [voyageColors_sidecar_1.voyageColors.yellow, 0xffffff];
var randomizeStar = function (obj) {
    var cb = voyageCamera_sidecar_1.voyageCamera.get().bounds;
    var x = rando_sidecar_1.rando.f(cb.x, cb.x + cb.w);
    var y = rando_sidecar_1.rando.f(cb.y, cb.y + cb.h);
    obj.x = x;
    obj.y = y;
    obj.image.x = x;
    obj.image.y = y;
    obj.depth = rando_sidecar_1.rando.f(0.1, 1);
    spritesUtil_sidecar_1.spritesUtil.scale(obj.image, Math.floor(obj.depth * 2));
    obj.image.depth = obj.depth;
    obj.image.tint = rando_sidecar_1.rando.sample(colors);
    obj.image.alpha = rando_sidecar_1.rando.f(0.5, 1);
    obj.image.scaleY = rando_sidecar_1.rando.fj(0.5, 0.75);
};
var createStar = function () {
    var image = spritesUtil_sidecar_1.spritesUtil.createImage(rando_sidecar_1.rando.sample([voyageLayers_sidecar_1.voyageLayers.getLayers().starfield2]), rando_sidecar_1.rando.sample([sprites_sidecar_1.sprites.voyHyper[0]]));
    var obj = {
        image: image,
        x: 0,
        y: 0,
        depth: 1,
    };
    objs.push(obj);
    return obj;
};
var objs = [];
function updateAll() {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var cb = voyageCamera_sidecar_1.voyageCamera.get().bounds;
    var maxSpeed = 10000;
    var speed = maxSpeed * _speed;
    var stretch = 200 * (speed / maxSpeed);
    voyageLayers_sidecar_1.voyageLayers.getLayers().starfield1.visible = speed <= 0;
    voyageLayers_sidecar_1.voyageLayers.getLayers().starfield2.visible = speed > 0;
    if (speed <= 0) {
        return;
    }
    for (var i = 0; i < objs.length; i++) {
        var c = objs[i];
        // c.x -= ds * c.depth * 20
        c.x -= ds * c.depth * speed;
        if (c.x < cb.x) {
            c.x += cb.w;
        }
        if (c.x > cb.x + cb.w) {
            c.x -= cb.w;
        }
        c.image.x = c.x; //  + -(cx - centerXY.x) * (1 - c.depth * depthScale) * scale
        c.image.y = c.y; // + -(cy - centerXY.y) * (1 - c.depth * depthScale) * scale
        c.image.scaleX = stretch * c.depth;
        //c.image.scaleY = 0.25
    }
}
exports.updateAll = updateAll;
function setSpeed(speed) {
    _speed = speed;
}
exports.setSpeed = setSpeed;
